var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-album", { attrs: { profil: _vm.profil } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "albumMainBody" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sideMenu__close",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "profil" })
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "albumList__separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "albumListing__wrap" }, [
            _c("div", { staticClass: "albumList__half --first" }, [
              _c(
                "div",
                {
                  staticClass:
                    "albumList__heading mb-3 d-flex align-items-center justify-content-between"
                },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _vm._v("Kravička TV "),
                    _c("span", {
                      staticClass: "icon --questionMark",
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.show("modalAlbumAnatomia")
                        }
                      }
                    })
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.album.videosekcia
                ? _c(
                    "div",
                    { staticClass: "albumListing__list --videosekcia" },
                    _vm._l(_vm.album.videosekcia, function(video, index) {
                      return index >= _vm.startIndex &&
                        index <= _vm.endIndex - 6
                        ? _c(
                            "div",
                            {
                              staticClass: "albumListing__item",
                              on: {
                                click: function($event) {
                                  return _vm.playVideo(video, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "http://img.youtube.com/vi/" +
                                        video.album_videosekcia_video +
                                        "/maxresdefault.jpg",
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "buttonWrapper" }, [
                                    _vm._m(1, true),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "duration" }, [
                                      _vm._v(
                                        _vm._s(video.album_videosekcia_dlzka)
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "albumListing__name mb-0" },
                                    [
                                      _vm._v(
                                        _vm._s(video.album_videosekcia_nadpis)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.album.videosekcia
              ? _c("div", { staticClass: "albumList__half --second" }, [
                  _c(
                    "div",
                    { staticClass: "albumListing__list --videosekcia" },
                    _vm._l(_vm.album.videosekcia, function(video, index) {
                      return index >= _vm.startIndex + 6 &&
                        index <= _vm.endIndex
                        ? _c(
                            "div",
                            {
                              staticClass: "albumListing__item",
                              on: {
                                click: function($event) {
                                  return _vm.playVideo(video, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "http://img.youtube.com/vi/" +
                                        video.album_videosekcia_video +
                                        "/maxresdefault.jpg",
                                      alt: ""
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "buttonWrapper" }, [
                                    _vm._m(2, true),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "duration" }, [
                                      _vm._v(
                                        _vm._s(video.album_videosekcia_dlzka)
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "albumListing__name mb-0" },
                                    [
                                      _vm._v(
                                        _vm._s(video.album_videosekcia_nadpis)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.prevPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --prev",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon --prev" }),
                  _vm._v("Predchádzajúca strana\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nextPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --next",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage + 1)
                    }
                  }
                },
                [
                  _vm._v("\n                Ďalšia strana"),
                  _c("span", { staticClass: "icon --next" })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumAnatomia",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumAnatomia",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumAnatomiaTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumAnatomia")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { padding: "0" } },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "text-center" }, [_vm._v("Nápoveda")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-18" }, [
                  _vm._v(
                    'Tvoj nový online "televízny" kanál plný kravičiek je tu. Spoznaj svet kravičiek a nauč sa, ako žijú a ako sa o ne farmári na farmách starajú.'
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumVideo",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumVideo",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumVideoTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumVideo")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal-body o-modalInfo",
              staticStyle: { padding: "0" }
            },
            [
              _c(
                "div",
                { staticClass: "m-modalLostPassword__content text-center" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "videoWrapper",
                      staticStyle: {
                        position: "relative",
                        "padding-bottom": "56.25%",
                        "padding-top": "25px",
                        height: "0"
                      }
                    },
                    [
                      _c("iframe", {
                        staticStyle: {
                          position: "absolute",
                          top: "0",
                          left: "0",
                          width: "100%",
                          height: "100%"
                        },
                        attrs: {
                          width: "420",
                          height: "315",
                          src:
                            "https://www.youtube.com/embed/" + _vm.modal_video,
                          frameborder: "0",
                          allowfullscreen: ""
                        }
                      })
                    ]
                  )
                ]
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "albumPages" }, [
      _c("div", { staticClass: "albumPage --first" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --second" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --third" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --fourth" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "btn --primary" }, [
      _c("span", { staticClass: "icon --videoPlay" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "btn --primary" }, [
      _c("span", { staticClass: "icon --videoPlay" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }